import { render } from "./recentTeamingWin.vue?vue&type=template&id=637a4bfc"
import script from "./recentTeamingWin.vue?vue&type=script&lang=js"
export * from "./recentTeamingWin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__